/**
 * 単一項目のフォームフィールド名を作る（#3309）。
 *
 * react-hook-form のキーは項目名をそのまま使わず、小文字化と空白置換をしている。
 * 一方でバリデーションスキーマ（validation/pattern）は項目名をそのまま
 * キーにしていたため、項目名に大文字や空白が含まれると両者がズレて、
 * スキーマが常に undefined を検証する＝制約が一切効かない状態になっていた。
 *   例: 「納入先ID」→ フォームは "納入先id" / スキーマは "納入先ID"
 *
 * 値の出し入れ・スキーマ登録・エラー参照のすべてがこの関数を通るようにして、
 * 片方だけ変えるとズレる状態をなくす。
 */
export const toFormFieldName = (parentValue: string): string =>
  parentValue.toLowerCase().replace(/\s+/g, '_');
